import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";

import "./styles/tokens.css";
import "./styles/board.css";
import "./styles/screens.css";

// The theme and the language were already applied by the inline script in index.html, before the
// first paint. Nothing here re-applies them: a remembered choice that flashes the other way for one
// frame is worse than no memory at all.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
